export default "__VITE_ASSET__Dv$05tsZ__"